export default function (instance) {
  return {
    getCart ({ bundles, excludePrice, zipCode }) {
      return instance
        .post('/api/shoppingcart/request', {
          bundles,
          excludePrice,
          zipCode
        })
        .then(response => response.data)
    },

    validateMaxQuantity (bundles) {
      return instance
        .post('/api/shoppingcart/validation/maxQuantity', { bundles })
        .then(response => response.data)
    }
  }
}
